export const makeCounter = (initial: number = 1) => {
  let current = initial;
  return function () {
    return current++;
  };
};